/** @format */

export default function() {
  return [
    // {
    // title: '序号',
    // width: 70,
    // customRender: this.renderIndexNumOfTheFirstColumn,
    // },
    {
      title: '车场名称',
      dataIndex: 'parkName',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse-to-tip' }
    },
    {
      title: '车牌号',
      dataIndex: 'plate',
      width: 120,
      scopedSlots: { customRender: 'click-to-detail' }
    },
    {
      title: '入口通道',
      dataIndex: 'enterChannelName',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse-to-tip' }
    },
    {
      title: '入场时间',
      dataIndex: 'enterTime',
      width: 200,
      sortable: true
    },
    {
      title: '出口通道',
      dataIndex: 'exitChannelName',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse-to-tip' }
    },
    {
      title: '出场时间',
      dataIndex: 'exitTime',
      width: 200,
      sortable: true
    },
    {
      title: '放行原因',
      dataIndex: 'releaseCauseName',
      width: 220,
      scopedSlots: { customRender: 'text-ellipse-20' }
    },
    {
      title: '应收金额',
      dataIndex: 'totalAmount',
      width: 140,
      sortable: true
    },

    {
      title: '实收金额',
      dataIndex: 'paidAmount',
      width: 140
    },
    {
      title: '优惠金额',
      dataIndex: 'discountAmount',
      width: 140
    },

    {
      title: '应收未收',
      dataIndex: 'unpaidAmount',
      width: 140,
      sortable: true,
      customRender: (text: any, record: any, index: number) =>
        record['uncollectedAmount' in record ? 'uncollectedAmount' : 'unpaidAmount']
    },
    {
      title: '减免金额',
      dataIndex: 'cancelAmount',
      width: 140,
      sortable: true,
      customRender: (text: any, record: any, index: number) =>
        record['cancelAmount' in record ? 'cancelAmount' : 'specialAmount']
    },
    {
      title: '操作人',
      dataIndex: 'operater',
      width: 140,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '操作来源',
      dataIndex: 'source',
      width: 140,
      scopedSlots: { customRender: 'sourceName' }
    },
    {
      title: '审核状态',
      dataIndex: 'reviewStatusName',
      width: 100,
      scopedSlots: { customRender: 'status' }
    },
    {
      title: '审核时间',
      dataIndex: 'reviewTime',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '审核意见',
      dataIndex: 'reviewDescription',
      width: 160,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '审核人',
      dataIndex: 'reviewer',
      width: 140,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '停车订单号',
      dataIndex: 'pkOrderId',
      width: 340,
      scopedSlots: { customRender: 'pkOrderId' }
    }
    // {
    //   title: '审核时间',
    //   dataIndex: 'reviewTime',
    //   width: 100,
    // },
    // {
    //   title: '审核意见',
    //   dataIndex: 'reviewDescription',
    //   width: 100,
    // },
    // {
    //   title: '出场图片',
    //   dataIndex: 'exitImg',
    //   width: 100,
    //   scopedSlots: { customRender: 'viewImg' },
    // },

    // {
    //   title: '操作',
    //   dataIndex: 'operation',
    //   fixed: 'right',
    //   width: 180,
    //   scopedSlots: { customRender: 'operation' },
    // },
    // {
    //   title: '操作',
    //   dataIndex: 'operation',
    //   fixed: 'right',
    //   width: 154,
    //   scopedSlots: { customRender: 'operation' },
    // },
  ];
}
